/**
 * Capa 2: Cortafuegos de Saneamiento de Red y Desechos Acústicos
 * Elimina artefactos de serialización JSON y ruidos de respiración mapeados erróneamente.
 */
export function sanearResiduosDeRed(text: string): string {
  if (!text) return "";

  return text
    // 1. Corregir escapes de red que transforman el salto de línea en texto plano literal
    .replace(/\\n/g, '\n')
    
    // 2. Fulminar tokens basura de desecho acústico (respiraciones/carraspeos del radiólogo)
    .replace(/\b[nN]\s*[/\\]\s*[nN]\b/g, '\n\n') // "n n/" o "n/n" pasa a ser doble párrafo
    .replace(/\b[nN]\s*[/\\]/g, '\n')           // "n/" pasa a ser salto de línea
    .replace(/[/\\][nN]\b/g, '\n')              // "/n" pasa a ser salto de línea
    
    // 3. Normalizar comandos estructurales que se le hayan colado en texto al LLM
    .replace(/nueva l[ií]nea/gi, '\n')
    .replace(/nuevo p[aá]rrafo/gi, '\n\n')
    .replace(/punto aparte/gi, '.\n\n')
    
    // 4. Colapsar acumulaciones redundantes de saltos de línea (máximo 2)
    .replace(/\n{3,}/g, '\n\n');
}

export function normalizeMedicalText(text: string): string {
  if (!text) return "";

  // PASO 0: Descontaminación global prioritaria
  let cleaned = sanearResiduosDeRed(text);

  // Parche volumétrico 3D (ej: "4 x 4x4cm" -> "4x4x4cm")
  cleaned = cleaned.replace(/(\d+)\s*x\s*(\d+)/gi, "$1x$2");

  // 1. Unificación y compresión de dimensiones con unidades
  cleaned = cleaned.replace(/(\d+)\s*(x|por|con)\s*(\d+)\s*(centímetros|centimetro|cm)/gi, "$1x$3cm");
  cleaned = cleaned.replace(/(\d+)\s*(x|por|con)\s*(\d+)\s*(milímetros|milimetro|mm)/gi, "$1x$3mm");

  // 2. Filtro residual para dimensiones solas
  cleaned = cleaned.replace(/(\d+)\s+(por|con)\s+(\d+)/gi, "$1x$3");

  // 3. Compresión de unidades sueltas estándar
  cleaned = cleaned.replace(/(\d+)\s+(cm|cc|mm|ml|gr|mg|ug|%)/gi, "$1$2");

  // 4. Rangos numéricos
  cleaned = cleaned.replace(/de\s+(\d+)\s+a\s+(\d+)/gi, "$1-$2");

  // 5. Nomenclatura Vertebral Estricta (Blindada contra falsos positivos dimensionales)
  cleaned = cleaned.replace(/\bcervical\s+(?:cinco|5)\b(?!\s*(?:cm|mm|centímetro|milímetro))/gi, "C5");
  cleaned = cleaned.replace(/\bdorsal\s+(?:diez|10)\b(?!\s*(?:cm|mm|centímetro|milímetro))/gi, "D10");
  cleaned = cleaned.replace(/lumbar\s+(cuatro|4)\s+a\s+(cinco|5)/gi, "L4-L5");
  
  cleaned = cleaned.replace(/\blumbar\s+(\d+)\s+a\s+(\d+)\b/gi, 'L$1-L$2');
  cleaned = cleaned.replace(/\bcervical\s+(\d+)\b(?!\s*(?:cm|mm|centímetro|milímetro))/gi, 'C$1');

  return cleaned.trim();
}
